var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95432 31.0457 0 20 0C8.95431 0 0 8.95432 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#EDF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6118 15.0326C22.6793 15.0326 24.3554 13.3424 24.3554 11.2575C24.3554 9.17259 22.6793 7.48242 20.6118 7.48242C18.5442 7.48242 16.8682 9.17259 16.8682 11.2575C16.8682 13.3424 18.5442 15.0326 20.6118 15.0326Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.12 18.7094C24.5573 18.4774 23.9406 18.3496 23.2932 18.3496H18.1136C15.4511 18.3496 13.3076 20.5111 13.3076 23.196V28.9294C13.3076 29.6642 13.8942 30.2557 14.6229 30.2557H26.7839C27.5125 30.2557 28.0991 29.6642 28.0991 28.9294V27.4037",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6129 16.9365L32.6962 19.0241L26.226 25.5076L23.8535 25.7975L24.1427 23.4201L30.6129 16.9365Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5586 18.9941L30.6419 21.0817",
    stroke: "black",
    strokeWidth: 1.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.10308b5c8aa02f5ad1195fe6ae54945e.svg";
export { ForwardRef as ReactComponent };